<template>
  <div class="container auth-page">
    <div class="row">
      <div class="col-xs-12 col-md-8 col-md-offset-2">
        <div class="panel panel-default">
          <div class="panel-heading"><strong>Register</strong></div>
          <div class="panel-body">
            <div class="cell form-wrapper">
              <Form v-slot="{ handleSubmit}" :validation-schema="schema" as="div">
                <form
                  class="form-horizontal sign-up-form"
                  role="form"
                  id="sign-up-form"
                  @submit="handleSubmit($event, register)"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <h3>Your Details:</h3>

                      <div class="form-group">
                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Your First Name</label>
                          <Field type="text" class="form-control" name="first_name" v-model="user.first_name" placeholder="Your First Name"/>
                          <ErrorMessage class="error_message" name="first_name" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Your Last Name</label>
                          <Field type="text" class="form-control" name="last_name" v-model="user.last_name" placeholder="Your First Name"/>
                          <ErrorMessage class="error_message" name="last_name" />
                        </div>

                        <div class="col-sm-12 form-group no-marg">
                          <label class="control-label">Your Company Name</label>
                          <Field type="text" class="form-control" name="company_name" label="Company Name" v-model="user.company_name" placeholder="Your Company Name"/>
                          <ErrorMessage class="error_message" name="company_name" />
                        </div>

                        <div class="col-sm-12 form-group no-marg">
                          <label class="control-label">E-Mail Address</label>
                          <Field type="text" class="form-control" name="email" v-model="user.email" placeholder="E-Mail Address"/>
                          <ErrorMessage class="error_message" name="email" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Password</label>
                          <Field type="password" class="form-control" name="password" v-model="user.password" placeholder="Password"/>
                          <ErrorMessage class="error_message" name="password" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Confirm Password</label>
                          <Field type="password" class="form-control" name="password_confirmation" v-model="user.password_confirmation" placeholder="Confirm Passwor"/>
                          <ErrorMessage class="error_message" name="password_confirmation" />
                        </div>
                      </div>

                      <button
                          type="submit"
                          class="btn btn-primary submit"
                      >
                        Submit
                      </button>

                    </div>
                  </div>
                </form>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "RegisterInNetwork",
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
    };
  },
  computed: {
    schema() {
      return yup.object({
        first_name: yup.string().required().min(3).label('First Name'),
        last_name: yup.string().required().min(3).label('Last Name'),
        company_name: yup.string().required().min(3).label('Company Name'),
        email: yup.string().required().email().label('E-Mail Address'),
        password: yup.string().required().min(6).max(100).label('Password'),
        password_confirmation: yup.string().required().min(6).max(100).oneOf([yup.ref('password'), null], 'Passwords must match').label('Confirm Password'),

      });
    },
  },
  methods: {
    register() {
      let registrationData = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
        company_name: this.user.company_name,
      };

      axios
          .post(`/auth/register`, registrationData)
          .then((res) => {
            console.log("result", res);
            window.location.href = "/dashboard";
          })
          .catch((error) => {
            if (error.response) {
              this.errors = error.response.data.errors;
              let newArray = Object.values(error.response.data.errors).flat(3);
              console.log("newArray", newArray);
              console.log(error);
            }
          });
    },
  },
  created() {},
};
</script>

<style scoped>
.error_message {
  font-size: 12px;
  color: #d00000;
}
</style>